// extracted by mini-css-extract-plugin
export default {"toolbar":"Toolbar-theme-2_toolbar__9Zq8R","button":"Toolbar-theme-2_button__JLKFF"};